<div class="middle-box text-center animated fadeInDown">
    <h1>404</h1>
    <h3 class="font-bold">{{ 'NotFound.Header' | translate }}</h3>

    <div class="error-desc">
        {{ 'NotFound.Text' | translate }}
    </div>
    <button type="button" class="btn btn-primary m-t-sm" (click)="back()">{{ 'NotFound.BackBtn' | translate }}</button>
</div>
